module.exports = __webpack_public_path__ + "img/verification-main-img.332d47bd.png";